module.exports = __webpack_public_path__ + "static/img/csBanner@2x.e7bedf43.png";